import React from 'react';
function CallReceived() {
    return (React.createElement("g", null,
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z" })));
}
export default CallReceived;
